"use client";
import { useScrollReveal } from "@/hooks/common/useScrollReveal";

export default function OurMission() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section
      ref={ref}
      className={`py-16 md:py-24 pb-2 md:pb-4 bg-background transition-all duration-700 ${
        isVisible ? "animate-fade-in" : "opacity-0"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-8 text-center">
            Our Mission
          </h2>

          <p className="text-lg text-muted-foreground text-center max-w-3xl mx-auto mb-0">
            We help our members simplify how they protect their assets.
          </p>

          {/* Video Placeholder - HIDDEN */}
          {/* <div className="aspect-video bg-muted rounded-lg relative overflow-hidden border border-border mb-8 max-w-2xl mx-auto">
            <div className="absolute inset-0 bg-muted flex items-center justify-center">
              <div className="relative">
                <div className="w-20 h-20 md:w-24 md:h-24 bg-white rounded-full flex items-center justify-center shadow-lg">
                  <div className="w-16 h-16 md:w-20 md:h-20 bg-foreground rounded-full flex items-center justify-center">
                    <div className="w-0 h-0 border-t-12 md:border-t-14 border-t-transparent border-l-18 md:border-l-22 border-l-white border-b-12 md:border-b-14 border-b-transparent ml-1"></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute bottom-0 left-0 right-0 bg-foreground/90 h-10 flex items-center px-3 gap-3">
              <button className="text-white">
                <div className="w-0 h-0 border-t-[6px] border-t-transparent border-l-10 border-l-white border-b-[6px] border-b-transparent"></div>
              </button>
              <span className="text-white text-xs">00:00</span>
              <div className="flex-1 bg-muted-foreground/30 h-1 rounded-full overflow-hidden">
                <div className="bg-white h-full w-0"></div>
              </div>
              <span className="text-white text-xs">00:00</span>
              <button className="text-white text-xs">
                <svg
                  className="w-4 h-4"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z" />
                </svg>
              </button>
              <button className="text-white text-xs">
                <svg
                  className="w-4 h-4"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
                </svg>
              </button>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
